import { inject } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

const ICONS = ['pickups-hotel', 'breakfast-cold', 'breakfast-hot', 'meal-cold', 'meal-hot'];

const ICONS_PATH = '/assets/svg/icons/';

export function registerIcons() {
  const iconRegistry = inject(MatIconRegistry);
  const sanitizer = inject(DomSanitizer);

  ICONS.forEach((name) => {
    iconRegistry.addSvgIcon(
      name,
      sanitizer.bypassSecurityTrustResourceUrl(`${ICONS_PATH}${name}.svg`),
    );
  });
}
